<!--  表單標題 -->
<template>
<div class="sub-content"><slot></slot></div>
</template>
<script>
export default {
  name: 'sub-content',
  data () {
    return {
    }
  }
}
</script>
<style lang="stylus" scoped>

.sub-content
  color $info-color-content
  padding-left:10px
  height: 40px
  display: flex
  align-items: center
  margin-bottom 10px
</style>
